import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { logout } from "../actions/auth";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import changeMain from "../actions/main";
import traemandLogo from "../img/traemandLogo.png";
import fieldnationLogo from "../img/fieldnationLogo.png";
import voxLogo from "../img/voxLogo.jpg";
import eymLogo from "../img/eymLogo.png";
import opieLogo from "../img/opieLogo.png";
import exemptaxLogo from "../img/exemptaxLogo.png";
import cgnLogo from "../img/cgnLogo.png";
import bestpassLogo from "../img/bestpassLogo.png";
import {
	BrowserView,
	MobileView,
	isBrowser,
	isMobile,
} from "react-device-detect";

class NavbarAlternate extends Component {
	state = {
		isMenuButtonToggled: false,
	};

	componentDidMount() {
		const menuItem = document.querySelectorAll(".navbar-nav .nav-item");
		const dropdownItem = document.querySelectorAll(
			".navbar-nav .dropdown-item"
		);
		// const dropDownMenu = document.querySelector('#navbarDropdown').addEventListener('touchend', () => alert('Hi'))
		// console.log(dropDownMenu)
		for (let i = 0; i < menuItem.length; i++) {
			menuItem[i].addEventListener(
				"click",
				this.closeDropDownOnMenuClick
			);
		}
		for (let i = 0; i < dropdownItem.length; i++) {
			dropdownItem[i].addEventListener(
				"click",
				this.closeDropDownOnMenuClick
			);
		}
	}

	closeDropDownOnMenuClick = () => {
		this.setState({ isMenuButtonToggled: !this.state.isMenuButtonToggled });
	};

	renderUserName = (username) => {
		if (username) {
			return "Hi " + username.charAt(0).toUpperCase() + username.slice(1);
		}
		return "";
	};

	render() {
		let getProject = process.env.REACT_APP_EYMIO_BASE_PROJECT;

		let { endpoints } = this.props;

		// console.log("endpoints",endpoints)

		let getPreferenceList;

		for (let n in endpoints) {
			if (endpoints[n].name === "preferences") {
				getPreferenceList = endpoints[n].list;
			}
		}

		let getPreference = getPreferenceList && getPreferenceList[0];

		let getSBT;

		if (getPreference) {
			getSBT = getPreference.sandbox_type;
		}

		// console.log("getPreference",getPreference)

		// console.log("getSBT",getSBT)

		let selectLogo;
		let selectLogoSize;

		if (getSBT === "eym") {
			selectLogo = eymLogo;
			selectLogoSize = "30px";
		} else if (getSBT === "vox") {
			selectLogo = voxLogo;
			selectLogoSize = "40px";
		} else if (getSBT === "trm") {
			selectLogo = traemandLogo;
			selectLogoSize = "40px";
		} else if (getSBT === "fnt") {
			selectLogo = fieldnationLogo;
			selectLogoSize = "25px";
		} else if (getSBT === "opie") {
			selectLogo = opieLogo;
			selectLogoSize = "25px";
		} else if (getSBT === "etax") {
			selectLogo = exemptaxLogo;
			selectLogoSize = "25px";
		} else if (getSBT === "cgn") {
			selectLogo = cgnLogo;
			selectLogoSize = "25px";
		} else if (getSBT === "bsp") {
			selectLogo = bestpassLogo;
			selectLogoSize = "25px";
		}

		let { handleClick, sidebars } = this.props;
		let links = sidebars.map((sidebar, index) => {
			if (
				sidebar.config.adminOnly &&
				this.props.auth.user &&
				!this.props.auth.user.isAdmin
			) {
				return null;
			}

			let dropdownLinks = sidebar.children.map((child, index) => {
				let clk =
					child.type === "endpoint" ? () => handleClick(child) : null;
				let routePath = child.label.toLowerCase();
				if (
					child.config.adminOnly &&
					this.props.auth.user &&
					!this.props.auth.user.isAdmin
				) {
					return null;
				}

				return (
					<Link
						key={index}
						to={`/${routePath}`}
						onClick={clk}
						className="dropdown-item py-2"
					>
						{child.label}
					</Link>
				);
			});

			switch (sidebar.type) {
				case "endpoint": {
					let routePath = sidebar.label.toLowerCase();
					return (
						<li
							key={index}
							className="nav-item"
							onClick={this.closeDropDownOnMenuClick}
						>
							<Link
								to={`/${routePath}`}
								onClick={() => handleClick(sidebar)}
								className="nav-link"
							>
								{sidebar.label}
							</Link>
						</li>
					);
				}
				case "dropdown": {
					return (
						<li key={index} className="nav-item dropdown">
							<a
								href="#!"
								className="nav-link dropdown-toggle"
								id="navbarDropdown"
								role="button"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
								onClick={this.closeDropDownOnMenuClick}
							>
								{" "}
								{sidebar.label}{" "}
							</a>
							<div
								className="dropdown-menu py-0"
								aria-labelledby="navbarDropdown"
							>
								{dropdownLinks}
							</div>
						</li>
					);
				}
				default: {
					let routePath = sidebar.label.toLowerCase();
					return (
						<li
							key={index}
							className="nav-item"
							onClick={this.closeDropDownOnMenuClick}
						>
							<Link
								to={`/${routePath}`}
								onClick={() => handleClick(sidebar)}
								className="nav-link py-2"
							>
								{sidebar.label}
							</Link>
						</li>
					);
				}
			}
		});

		let { dispatch, auth } = this.props;
		const isVerified = this.props.auth.user.emailVerified;
		return (
			<div id="navigation-section">
				<div className="excelym-theme-bar"></div>
				{isVerified ? (
					<nav
						id="TopNavBar"
						className="navbar bg-white navbar-expand-lg shadow"
					>
						<div className="float-left">
							<div className="fa-animation">
								<i className="fa fa-cog fa-lg fa-spin"></i>
								<i className="fa fa-cog fa-md fa-spin"></i>
								<i className="fa fa-cog fa-xs fa-spin"></i>
							</div>
							<Link
								to={"/"}
								className="navbar-brand float-left ml-4 pl-3"
							>
								<span style={{ color: "#0FB8DB" }}>
									Excelym
								</span>{" "}
								<strong>IO</strong>
							</Link>							
						</div>
						{process.env.REACT_APP_ENV_INSTANCE == 'sandbox' ? <strong className="navbar-brand-sb">SANDBOX</strong>
						: ''}
						{selectLogo ? (
							<div className="image-container">
								<img
									// src="https://i.ibb.co/Kjh6jZD/traemand-logo.png"
									src={selectLogo}
									alt="new"
									style={{ height: selectLogoSize }}
								/>
							</div>
						) : (
							<i className="fas  fa-spinner fa-spin"></i>
						)}

						<button
							className={`navbar-toggler btn ${
								this.state.isMenuButtonToggled
									? "collapsed"
									: ""
							}`}
							type="button"
							data-toggle="collapse"
							data-target="#excelym-navbar"
							aria-controls="excelym-navbar"
							aria-expanded="false"
							aria-label="Toggle navigation"
						>
							<span className="navbar-toggler-icon">
								<i className="fas fa-bars"></i>
							</span>
						</button>

						<div
							className={`collapse navbar-collapse px-3 ${
								this.state.isMenuButtonToggled ? "show" : ""
							}`}
							id="excelym-navbar"
						>
							<ul className="navbar-nav align-center">
								{isMobile ? "" : links}

								<div
									id="logout-btn-mobile"
									className="float-right dropdown mt-1 d-block d-lg-none"
									style={{ zIndex: "20" }}
								>
									<button
										className="btn btn-secondary dropdown-toggle"
										type="button"
										id="dropdownMenuButton1"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<i className="fas fa-user"></i>
									</button>
									<div
										className="dropdown-menu dropdown-menu-right py-0"
										aria-labelledby="dropdownMenuButton1"
									>
										{isMobile ? (
											""
										) : (
											<Link
												className="dropdown-item"
												to="#"
											>
												Change Password
											</Link>
										)}
										{/* <Link className="dropdown-item" to="#">Another action</Link>
                                <Link className="dropdown-item" to="#">Something else here</Link> */}
										<Link
											to=""
											className="dropdown-item"
											onClick={() => {
												dispatch(
													logout(auth.access_token)
												);
											}}
										>
											Logout
										</Link>
									</div>
								</div>

								<div
									id="logout-btn"
									className="float-right dropdown mt-1 d-none d-lg-block"
									style={{ zIndex: "20" }}
								>
									<button
										className="btn btn-secondary dropdown-toggle"
										type="button"
										id="dropdownMenuButton2"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<span
											id="user-name"
											className={`${
												this.renderUserName(
													this.props.auth.user
														.username
												) !== ""
													? "mr-2"
													: ""
											}`}
										>
											{this.renderUserName(
												this.props.auth.user.username
											)}
										</span>
										<i className="fas fa-user"></i>
									</button>
									<div
										className="dropdown-menu dropdown-menu-right py-0"
										aria-labelledby="dropdownMenuButton2"
									>
										<Link
											className="dropdown-item"
											to="/about-excelymio"
										>
											About Excelym.IO
										</Link>
										<Link
											className="dropdown-item"
											to="/change-password"
										>
											Change Password
										</Link>
										{/* <Link class="dropdown-item" to="#">Another action</Link>
                                <Link class="dropdown-item" to="#">Something else here</Link> */}

										<Link
											className="dropdown-item"
											to="/user-preference"
										>
											User Preferences
										</Link>
										<Link
											to=""
											className="dropdown-item"
											onClick={() => {
												dispatch(
													logout(auth.access_token)
												);
											}}
										>
											Logout
										</Link>
									</div>
								</div>
							</ul>
						</div>
					</nav>
				) : (
					<nav
						id="TopNavBar"
						className="navbar bg-white navbar-expand-lg shadow"
					>
						<div className="float-left">
							<div className="fa-animation">
								<i className="fa fa-cog fa-lg fa-spin"></i>
								<i className="fa fa-cog fa-md fa-spin"></i>
								<i className="fa fa-cog fa-xs fa-spin"></i>
							</div>
							<Link
								to={"/change-password"}
								className="navbar-brand float-left ml-4 pl-3"
							>
								<span style={{ color: "#0FB8DB" }}>
									Excelym
								</span>{" "}
								<strong>IO</strong>
							</Link>
						</div>

						<button
							className={`navbar-toggler btn ${
								this.state.isMenuButtonToggled
									? "collapsed"
									: ""
							}`}
							type="button"
							data-toggle="collapse"
							data-target="#excelym-navbar"
							aria-controls="excelym-navbar"
							aria-expanded="false"
							aria-label="Toggle navigation"
						>
							<span className="navbar-toggler-icon">
								<i className="fas fa-bars"></i>
							</span>
						</button>

						<div
							className={`collapse navbar-collapse px-3 ${
								this.state.isMenuButtonToggled ? "show" : ""
							}`}
							id="excelym-navbar"
						>
							<div
								id="logout-btn-mobile"
								className="float-right dropdown mt-1 d-block d-lg-none"
								style={{ zIndex: "20" }}
							>
								<button
									className="btn btn-secondary dropdown-toggle"
									type="button"
									id="dropdownMenuButton1"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<i className="fas fa-user"></i>
								</button>
								<div
									className="dropdown-menu dropdown-menu-right py-0"
									aria-labelledby="dropdownMenuButton1"
								>
									<Link className="dropdown-item" to="#">
										Change Password
									</Link>
									{/* <Link className="dropdown-item" to="#">Another action</Link>
                                <Link className="dropdown-item" to="#">Something else here</Link> */}
									<Link
										to=""
										className="dropdown-item"
										onClick={() => {
											dispatch(logout(auth.access_token));
										}}
									>
										Logout
									</Link>
								</div>
							</div>

							<div
								id="logout-btn"
								className="float-right dropdown mt-1 d-none d-lg-block"
								style={{ zIndex: "20" }}
							>
								<button
									className="btn btn-secondary dropdown-toggle"
									type="button"
									id="dropdownMenuButton2"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<span
										id="user-name"
										className={`${
											this.renderUserName(
												this.props.auth.user.username
											) !== ""
												? "mr-2"
												: ""
										}`}
									>
										{this.renderUserName(
											this.props.auth.user.username
										)}
									</span>
									<i className="fas fa-user"></i>
								</button>
								<div
									className="dropdown-menu dropdown-menu-right py-0"
									aria-labelledby="dropdownMenuButton2"
								>
									<Link
										className="dropdown-item"
										to="/change-password"
									>
										Change Password
									</Link>
									{/* <Link class="dropdown-item" to="#">Another action</Link>
                                <Link class="dropdown-item" to="#">Something else here</Link> */}

									<Link
										to=""
										className="dropdown-item"
										onClick={() => {
											dispatch(logout(auth.access_token));
											this.props.location.push("/");
										}}
									>
										Logout
									</Link>
								</div>
							</div>
						</div>
					</nav>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth,
		endpoints: state.endpoints,
		// sidebars: state.sidebars
	};
}

function mapDispatchToProps(dispatch) {
	return {
		handleClick: (sidebar) => {
			dispatch(
				changeMain({
					endpointId: sidebar.endpointId ? sidebar.endpointId : null,
					endpointListId: null,
				})
			);
		},
		dispatch: dispatch,
	};
}

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(NavbarAlternate)
);



// WEBPACK FOOTER //
// ./src/components/NavbarAlternate.js